var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-card",
            {
              staticClass: "mb-0",
              attrs: {
                "footer-bg-variant": "white",
                "body-class": "py-0 document-container-body",
              },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-row justify-content-between",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "vertical-center" },
                            [
                              _c("b-skeleton", {
                                staticClass: "mt-2",
                                attrs: { width: "8rem" },
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                staticClass: "mt-2 ml-2",
                                attrs: { width: "1.5rem" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "mt-2",
                            attrs: {
                              width: "8rem",
                              height: "1.5rem",
                              type: "button",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "vertical-center" },
                        [
                          _c("b-skeleton", { attrs: { width: "40%" } }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "ml-2",
                            attrs: { width: "8rem", type: "button" },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "pt-4 pb-3 border-bottom" },
                [
                  _c(
                    "b-col",
                    { staticClass: "vertical-center", attrs: { cols: "auto" } },
                    [
                      _c("b-skeleton", {
                        staticClass: "mt-2",
                        attrs: { width: "1.5rem", height: "1.5rem" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "d-flex flex-row justify-content-between" },
                    [
                      _c(
                        "div",
                        { staticClass: "vertical-center" },
                        [
                          _c("b-skeleton", {
                            staticClass: "mt-2",
                            attrs: { width: "14rem", type: "button" },
                          }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "mt-2 ml-2",
                            attrs: { width: "13rem", type: "button" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "vertical-center" },
                        [
                          _c("b-skeleton", {
                            staticClass: "mt-2",
                            attrs: { width: "8rem", type: "button" },
                          }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "mt-2 ml-2",
                            attrs: { width: "8rem", type: "button" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "py-2" },
                [
                  _c(
                    "b-col",
                    { staticClass: "vertical-center", attrs: { cols: "auto" } },
                    [
                      _c("b-skeleton", {
                        attrs: { width: "1.5rem", height: "1.5rem" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex flex-row align-items-center justify-content-between",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "vertical-center" },
                        [_c("b-skeleton", { attrs: { width: "14rem" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "vertical-center" },
                        [
                          _c("b-skeleton", { attrs: { width: "4rem" } }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "ml-2",
                            attrs: { width: "1.5rem" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "py-2 border-top" },
                [
                  _c(
                    "b-col",
                    { staticClass: "vertical-center", attrs: { cols: "auto" } },
                    [
                      _c("b-skeleton", {
                        attrs: { width: "1.5rem", height: "1.5rem" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex flex-row align-items-center justify-content-between",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "vertical-center" },
                        [_c("b-skeleton", { attrs: { width: "14rem" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "vertical-center" },
                        [
                          _c("b-skeleton", { attrs: { width: "4rem" } }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "ml-2",
                            attrs: { width: "1.5rem" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }